module.exports = __webpack_public_path__ + "img/sidebar_christmas.50cd44c.png";